"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeStudyReport = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../common");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
const server_1 = require("../../../../server");
const HomeStudyReportStyled = styled_components_1.default.div `
	width: 100%;
	background: var(--color-white, #ffffff);
	border-radius: 12px;
	padding: ${({ $isMobile, $isTablet }) => ($isMobile ? '14px 16px' : $isTablet ? '14px 18px' : '16px 20px')};
	display: flex;
	flex-direction: ${({ $isDesktop }) => ($isDesktop ? 'row' : 'column')};
	gap: ${({ $isMobile }) => ($isMobile ? '10px' : '0')};
	align-items: flex-start;
	justify-content: flex-start;

	.home-study-report-desktop-line {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0;
	}

	.home-study-report-title {
		color: var(--color-black, #101010);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet, $isDesktop }) => $isMobile ? '20px' : $isTablet ? '24px' : $isDesktop ? '24px' : '24px'};
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 700;
		flex-shrink: 0;
	}

	.home-study-report-section {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
	}

	.home-study-report-divider {
		width: 1px;
		height: 36px;
		background: var(--color-grey-c, #e6e8ed);
		flex-shrink: 0;
	}

	.home-study-report-metrics {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 8px;
	}

	.home-study-report-item {
		color: var(--color-black, #101010);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet, $isDesktop }) => $isMobile ? '14px' : $isTablet ? '16px' : $isDesktop ? '18px' : '18px'};
		line-height: 150%;
		letter-spacing: -0.02em;
		font-weight: 500;
		word-break: keep-all;
		overflow-wrap: anywhere;
		padding: ${({ $isMobile }) => ($isMobile ? '0' : '0 60px')};
		${({ $isDesktop }) => !$isDesktop &&
    `
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center;
		`}
	}

	.metric-value {
		color: var(--color-grey, #666666);
		font-weight: 700;
	}

	.metric-unit {
		font-weight: 400;
	}

	.metric-divider {
		color: var(--color-grey-w, #b6bac0);
		margin: 0 4px;
	}

	.home-study-report-more {
		color: var(--color-grey, #666666);
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile, $isTablet, $isDesktop }) => $isMobile ? '14px' : $isTablet ? '15px' : $isDesktop ? '16px' : '16px'};
		line-height: 32px;
		letter-spacing: -0.02em;
		font-weight: 400;
		text-decoration: underline;
		border: 0;
		background: transparent;
		padding: 0;
		cursor: pointer;
	}

	.home-study-report-mobile-header {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
`;
exports.HomeStudyReport = react_1.default.memo(({ userId, hiddenMenus, onMore, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isDesktop, isTablet, isMobile, classesId } = (0, GlobalStateProvider_1.useGlobalState)();
    // 홈 학습 리포트는 월이 바뀌어도 전체 누적 표시 — conference-report(출석/지각/결석)와
    // test-report(미제출 과제) 모두 start_after/start_before 생략 시 서버가 전체 기간 집계 반환
    // (서버 확인 2026-08-03: '/~-report API' = 두 report API 모두를 지칭)
    const { data: conferenceReportData, refetch: conferenceReportRefetch } = (0, server_1.useConferenceReport)({
        id: userId,
    });
    const { data: assignmentReportData, refetch: assignmentReportRefetch } = (0, server_1.useGradeCardList)({
        id: userId,
        assignment: true,
    });
    const { data: enterableConferenceData, refetch: enterableConferenceRefetch } = (0, server_1.useConferenceList)({
        status: ['held', 'booked'],
        type: server_1.TEST_CONFERENCE_TYPE,
        orderby: ['startline ASC'],
    });
    (0, react_1.useEffect)(() => {
        if (!userId || !classesId)
            return;
        conferenceReportRefetch();
        assignmentReportRefetch();
        enterableConferenceRefetch();
    }, [
        userId,
        classesId,
        conferenceReportRefetch,
        assignmentReportRefetch,
        enterableConferenceRefetch,
    ]);
    const lateCount = conferenceReportData?.late || 0;
    const attendanceTotal = conferenceReportData?.total_count || 0;
    const attendanceDone = conferenceReportData?.done || 0;
    // 출결 집계 매핑(전체 현황 스펙): 출석 = done / 지각 = late / 결석 = 대상 − 출석 − 지각.
    // 지각 항목은 done=false 이므로 done 에서 late 를 다시 빼면 출석이 줄고 결석이 부풀려진다.
    // (학습현황 > 리포트의 [학습 요약]과 동일 기준 — 두 화면이 같은 API·같은 수치를 쓴다)
    const attendCount = attendanceDone;
    const absentCount = Math.max(attendanceTotal - attendanceDone - lateCount, 0);
    const notSubmitted = Math.max((assignmentReportData?.total_count || 0) - (assignmentReportData?.done || 0), 0);
    const openTestCount = (0, react_1.useMemo)(() => {
        const conferences = enterableConferenceData?.items || [];
        const now = new Date(enterableConferenceData?.server_time || new Date().toISOString()).getTime();
        const enterable = conferences.filter((item) => {
            if (item.status === 'held')
                return true;
            const startTime = new Date(item.start_time).getTime();
            const preEnteringTime = item.pre_entering_duration * 60 * 1000;
            return now >= startTime - preEnteringTime && now <= startTime;
        });
        return enterable.length;
    }, [enterableConferenceData]);
    if (hiddenMenus.includes('gradeCard'))
        return null;
    if (isDesktop) {
        return (react_1.default.createElement(HomeStudyReportStyled, { "$isMobile": false, "$isTablet": !!isTablet, "$isDesktop": !!isDesktop, className: "home-study-report" },
            react_1.default.createElement("div", { className: "home-study-report-section" },
                react_1.default.createElement("div", { className: "home-study-report-title" }, t('menu.studyReport'))),
            react_1.default.createElement("div", { className: "home-study-report-desktop-line" },
                react_1.default.createElement("div", { className: "home-study-report-section" },
                    react_1.default.createElement("div", { className: "home-study-report-item" },
                        t('conference.attendance'),
                        " ",
                        react_1.default.createElement("span", { className: "metric-value" }, attendCount),
                        ' ',
                        react_1.default.createElement("span", { className: "metric-unit" }, t('common.times')),
                        react_1.default.createElement("span", { className: "metric-divider" }, "\u00B7"),
                        t('conference.late'),
                        " ",
                        react_1.default.createElement("span", { className: "metric-value" }, lateCount),
                        ' ',
                        react_1.default.createElement("span", { className: "metric-unit" }, t('common.times')),
                        react_1.default.createElement("span", { className: "metric-divider" }, "\u00B7"),
                        t('conference.absent'),
                        " ",
                        react_1.default.createElement("span", { className: "metric-value" }, absentCount),
                        ' ',
                        react_1.default.createElement("span", { className: "metric-unit" }, t('common.times')))),
                react_1.default.createElement("div", { className: "home-study-report-divider" }),
                react_1.default.createElement("div", { className: "home-study-report-section" },
                    react_1.default.createElement("div", { className: "home-study-report-item" },
                        t('conference.inProgressTest'),
                        " ",
                        react_1.default.createElement("span", { className: "metric-value" }, openTestCount),
                        " ",
                        t('common.cases'))),
                react_1.default.createElement("div", { className: "home-study-report-divider" }),
                react_1.default.createElement("div", { className: "home-study-report-section" },
                    react_1.default.createElement("div", { className: "home-study-report-item" },
                        t('assignment.noStare'),
                        " ",
                        t('menu.assignment'),
                        "\t ",
                        react_1.default.createElement("span", { className: "metric-value" }, notSubmitted),
                        " ",
                        t('common.cases')))),
            react_1.default.createElement("div", { className: "home-study-report-section" },
                react_1.default.createElement("button", { type: "button", className: "home-study-report-more", onClick: onMore }, t('common.more')))));
    }
    return (react_1.default.createElement(HomeStudyReportStyled, { "$isMobile": isMobile, "$isTablet": isTablet, "$isDesktop": false, className: "home-study-report" },
        react_1.default.createElement("div", { className: "home-study-report-mobile-header" },
            react_1.default.createElement("div", { className: "home-study-report-title" }, t('menu.studyReport')),
            react_1.default.createElement(common_1.Button, { className: "more_detail", text: t('common.more'), onClick: onMore })),
        react_1.default.createElement("div", { className: "home-study-report-metrics" },
            react_1.default.createElement("div", { className: "home-study-report-item" },
                t('conference.attendance'),
                " ",
                react_1.default.createElement("span", { className: "metric-value" }, attendCount),
                ' ',
                react_1.default.createElement("span", { className: "metric-unit" }, t('common.times')),
                react_1.default.createElement("span", { className: "metric-divider" }, "\u00B7"),
                t('conference.late'),
                " ",
                react_1.default.createElement("span", { className: "metric-value" }, lateCount),
                ' ',
                react_1.default.createElement("span", { className: "metric-unit" }, t('common.times')),
                react_1.default.createElement("span", { className: "metric-divider" }, "\u00B7"),
                t('conference.absent'),
                " ",
                react_1.default.createElement("span", { className: "metric-value" }, absentCount),
                ' ',
                react_1.default.createElement("span", { className: "metric-unit" }, t('common.times'))),
            react_1.default.createElement("div", { className: "home-study-report-item" },
                t('conference.inProgressTest'),
                " ",
                react_1.default.createElement("span", { className: "metric-value" }, openTestCount),
                " ",
                t('common.cases')),
            react_1.default.createElement("div", { className: "home-study-report-item" },
                t('assignment.notSubmitted'),
                " ",
                t('menu.assignment'),
                " ",
                react_1.default.createElement("span", { className: "metric-value" }, notSubmitted),
                " ",
                t('common.cases')))));
});
